<template>
    <div class="header" :style="{ height: `${config.headerHeight}px` }">
        <div class="mobile-content" v-if="config.layout === 'mobile'">
            <div class="action-bar">
                <div class="left">
                    <div v-if="showQuestion">
                        <span>{{ showQuestion.indexNo }}</span>
                        <span>/{{ paperInfo.questionCnt }}</span>
                    </div>
                    <div v-else>-</div>
                </div>
                <div class="action">
                    <span class="time">{{ timeText }}</span>
                    <!-- <div @click="onCollectionChange" v-if="showQuestion">
                        <van-icon v-if="collectionMap[`q-${showQuestion.id}`]" name="star" />
                        <van-icon v-else name="star-o" />
                    </div> -->
                    <div @click="onShowQuestionCard">
                        <van-icon name="notes-o" />
                        <span>答题卡</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tablet-content" v-else-if="config.layout === 'tablet'">
            <div class="action-bar">
                <div v-if="showQuestion">
                    <span>{{ showQuestion.indexNo }}</span>
                    <span>/{{ paperInfo.questionCnt }}</span>
                </div>
                <div v-else>-</div>
                <div class="action">
                    <span class="time">{{ timeText }}</span>
                    <!-- <div @click="onCollectionChange" v-if="showQuestion">
                        <van-icon v-if="collectionMap[`q-${showQuestion.id}`]" name="star" />
                        <van-icon v-else name="star-o" />
                    </div> -->
                    <div class="card" @click="onShowQuestionCard">
                        <van-icon name="notes-o" />
                        <span>答题卡</span>
                    </div>
                </div>
            </div>
            <div v-if="quesitonProgress" class="progress">
                <span :style="{ width: `${quesitonProgress}%` }"></span>
            </div>
        </div>
    </div>
</template>
<script>
import { getDurationText } from '@/utils/tools.js'
import { putCollection, delCollection } from '@/api/paperApi.js'

export default {
    computed: {
        config() {
            return this.$store.state.paperDetails.config
        },
        paperInfo() {
            return this.$store.state.paperDetails.paperInfo
        },
        collectionMap() {
            return this.$store.state.paperDetails.collectionMap
        },
        moduleList() {
            return this.$store.state.paperDetails.moduleList
        },
        showQuestion: () => {
            if (this.$store.state.paperDetails.currentSubQuestion) {
                return this.$store.state.paperDetails.currentSubQuestion
            }
            if (this.$store.state.paperDetails.currentQuestion) {
                return this.$store.state.paperDetails.currentQuestion
            }
            return null
        },
        quesitonProgress() {
            const state = this.$store.state.paperDetails
            if (state.currentSubQuestion) {
                const _n = state.currentSubQuestion.questionIndex / state.paperInfo.questionCnt
                return parseInt(_n * 100)
            } else if (state.currentQuestion) {
                const _n = state.currentQuestion.questionIndex / state.paperInfo.questionCnt
                return parseInt(_n * 100)
            }
            return 0
        },
        timeText() {
            const answerTime = this.$store.state.paperDetails.answerTime
            let num = parseInt((answerTime.endTime - answerTime.startTime) / 1000)
            return getDurationText(num > 0 ? num : 0, 'minute')
        },
    },

    methods: {
        onClosePage() {
            this.$emit('onClosePage')
        },
        onShowQuestionCard() {
            this.$store.dispatch('paperDetails/setQuestionCardState', true)
        },
        onCollectionChange() {
            if (!this.showQuestion) return
            if (this.collectionMap[`q-${this.showQuestion.id}`]) {
                delCollection({
                    type: 'COLLECT',
                    questionId: this.showQuestion.id,
                }).then(() => {
                    this.$store.dispatch('paperDetails/setCollectionMap', { [`q-${this.showQuestion.id}`]: false })
                })
            } else {
                putCollection({
                    type: 'COLLECT',
                    paperNo: this.paperInfo.paperNo,
                    questionId: this.showQuestion.id,
                }).then(() => {
                    this.$toast('收藏成功')
                    this.$store.dispatch('paperDetails/setCollectionMap', { [`q-${this.showQuestion.id}`]: true })
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.header {
    width: 100%;
    box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.2);
}

.van-icon-star,
.van-icon-star-o {
    margin: 0 12px;
}
.van-icon-star {
    color: #ff8c00 !important;
}
.mobile-content {
    .action-bar {
        height: 42px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            display: flex;
            align-items: center;
            margin-left: 12px;
            .time {
                font-size: 16px;
                color: #333;
            }
        }
        .action {
            margin-right: 12px;
            display: flex;
            align-items: center;
            > div {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #333;
                .van-icon {
                    font-size: 18px;
                    color: #000;
                    margin: 0 4px 0 12px;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.tablet-content {
    .action-bar {
        height: 42px;
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .action {
            flex-shrink: 0;
            margin-right: 12px;
            display: flex;
            align-items: center;
            .time {
                font-size: 16px;
                color: #333;
            }
            .card {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #333;
                .van-icon {
                    font-size: 18px;
                    color: #000;
                    margin: 0 4px;
                }
            }
        }
    }
    .progress {
        width: 100%;
        height: 3px;
        position: relative;
        background: rgba($color: #ff8c00, $alpha: 0.1);
        span {
            display: block;
            width: 20%;
            height: 100%;
            background: #ff8c00;
        }
    }
}
</style>
